"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (fractionDigits, previous, iterator) => (parseFloat(previous) + iterator.next()).toFixed(fractionDigits);
//# sourceMappingURL=measurementItemMaker.js.map